import { useEffect, useState } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { isBrowser } from 'utils/helpers';

declare global {
  interface Window {
    onJustunoQuizVisible: () => void;
  }
}

type Props = {
  isJustunoLoadingState?: boolean;
};

export const useJustunoLoader = ({ isJustunoLoadingState }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const isRunningOnBrowser = isBrowser();

  const setJustUnoLoader = () => {
    if (isJustunoLoadingState) {
      setIsLoading(true);
    }
  };

  /**
   * Currently needed on justuno component while it is loading.
   * And it doesn't support the callback function.
   */
  useEffect(() => {
    if (!isLoading) return;
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, [isLoading]);

  useEffect(() => {
    if (!isRunningOnBrowser) return;

    window.onJustunoQuizVisible = () => {
      setIsLoading(false);

      analytics.track({
        event: ANALYTICS.EVENTS.VIEWED_COMPONENT,
        data: {
          label: 'JustunoSexualHealthQuiz',
          hookName: 'useJustunoLoader',
        },
      });
    };
  }, [isRunningOnBrowser]);

  return { isLoading, setJustUnoLoader };
};
